export default {
  title: 'Apps',
  fields: {
    id: 'ID',
    name: 'Navn',
    app_bundle_identifier: 'App Bundle-ID',
    released: 'Udgivet',
    franchise: 'Brand',
    app_icon: 'App-ikon',
    status: 'Status',
    play_store_link: 'Play Store-link',
    apple_store_link: 'Apple Store-link',
    dynamic_link: 'Dynamisk link - QR-koder',
  },
  filters: {
    name: 'Navn',
    released: 'Udgivet',
  },
  columns: {
    backlog: '📋 Backlog',
    ready_to_build: '🛠️ Klar til bygning',
    in_work: '🔧 I gang',
    in_review: '📝 Under gennemgang',
    rejected: '❌ Afvist',
    released: '✅ Udgivet',
    deactivated: '🛑 Deaktiveret',
  },
  card: {
    overdue: 'Forsinket · {{time}}',
    copied: 'Kopieret til udklipsholderen',
    released_tag: {
      both: '✅ Udgivet',
      ios: 'iOS udgivet',
      android: 'Android udgivet',
    },
    tags: {
      has_tech_issue: 'Teknisk problem',
    },
  },
  status_modal: {
    title: 'Opdater udgivelsesstatus',
    status_label: 'Status',
    note_label: 'Note (valgfri)',
    note_placeholder: 'Tilføj en valgfri note til denne statusændring',
    tech_issue_checkbox: 'Der er et teknisk problem',
    save: 'Gem',
    cancel: 'Annuller',
  },
  released: {
    yes: 'Ja',
    no: 'Nej',
  },
  configured_status: {
    true: 'Ja',
    false: 'Nej',
  },
  delete_confirmation: {
    title: 'Slet mobilapp',
    message: 'Er du sikker på, at du vil slette denne mobilapp?',
    buttons: {
      confirm: 'Bekræft',
      cancel: 'Annuller',
    },
  },
};
